import React from "react";
import "../Marketplace.scss";
import westernUnionLogo from "../../../images/western-union-logo.svg";
import moneyGramlogo from "../../../images/moneygram-logo.svg";
import riaLogo from "../../../images/rialogo.jpg";
import worldremit from "../../../images/WorldRemit_logo.jpg";
import { useNavigate } from "react-router-dom";
import BaseButton from "../../../components/UI/BaseButton/BaseButton";

function Remittance() {
  //loop through the setting options to add it to the list of settings
  //will need to add url to the link to navigate to the correct page

  // TODO update the options to have link (as seen in settings.jsx) and navigate to page with 3rd party integrations
  const navigate = useNavigate();
  const settingOptions = [
    {
      icon: westernUnionLogo,
      option: "Western Union",
      txt: "Enable Western Union Global network",
    },
    {
      icon: moneyGramlogo,
      option: "MoneyGram",
      txt: "Enable MoneyGram Global network",
    },
    {
      icon: worldremit,
      option: "World Remit",
      txt: "Enable WorldRemit Money network",
    },
    {
      icon: riaLogo,
      option: "RIA",
      txt: "Enable RIA Global Transfer network",
    },
  ];

  const goBack = () => {
    navigate("/marketplace");
  };

  return (
    <div className="page-container settings-container">
      <div className="header-container">
        <div className="settings-page-title">Remittance Partners</div>
        <div>
          Add a remittance partner to your platform. You must be a registered
          Money Services Business (MSB) or Financial Institution to leverage
          these services.
        </div>
      </div>
      <div className="settings-center-container">
        <div className="row gap-3">
          {settingOptions.map((setting) => {
            return (
              <div
                className="settings-card col-3"
                style={{
                  backgroundImage: `url(${setting.icon})`,
                  backgroundSize: "85%",
                  backgroundRepeat: "no-repeat",
                }}
              >{`${setting.txt}`}</div>
            );
          })}
        </div>
        <div className="return-button">
          <BaseButton
            buttonText={"Return to Marketplace"}
            onClick={goBack}
          ></BaseButton>
        </div>
      </div>
    </div>
  );
}

export default Remittance;
